module.exports = __webpack_public_path__ + "static/media/keep-safe-tip07.99acbd2f.png";